export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'The night sweats were the worst part — I was changing my shirt at 3am. Around day 5 I slept the whole night through for the first time in months. By week 3 my energy was back. I am not exaggerating.',
    name: 'Sarah M.',
    location: 'Boston · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/cf05f1a7-1ea7-499d-a210-e36aaa5d0a44.jpg',
  },
  {
    quote:
      'I spent two years and a lot of money on supplements that did nothing for the brain fog. The cooling strategies are what finally worked, and the belly bloat I could never shift is going down.',
    name: 'Jennifer L.',
    location: 'Vancouver · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/763f9619-902b-4a86-a0d1-798dd517abeb.jpg',
  },
  {
    quote:
      'I honestly felt like I had lost control of my own body and my moods. Having it laid out day by day made it simple — I just followed the checklist and felt steadier from the first week.',
    name: 'Linda D.',
    location: 'London · UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7722331a-4f43-4e7d-9218-df3ef0c1040d.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'The grocery list is on my fridge. I shop on Sunday and I have not had that awful 4pm crash since.',
    name: 'Lucy M.',
    location: 'California · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/94673299-a785-4d0e-8b3e-0338250757f7.jpg',
  },
  {
    quote:
      'I tried sleeping pills for a year and always woke up groggy. The sleep section fixed my nights in about three days.',
    name: 'Emma T.',
    location: 'London · UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/c47fd228-50cf-473b-837e-5c80833c3d81.jpg',
  },
  {
    quote:
      'I bought it for the hot flashes and stayed for the detox week. I feel lighter than I have in years — easily worth $27.',
    name: 'Rachel P.',
    location: 'Auckland · New Zealand',
    flag: '🇳🇿',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/fe62f7f6-3844-4fd5-9a9b-b6337d92bf57.jpg',
  },
];
